export default __webpack_public_path__ + "img/3.asset.05c8dd0e.jpeg";